import React, { Component } from 'react';
import { withRouter } from '../withRouter.js';
import api from '../services/api.js';
import apiString from '../services/apiString.js';
import apiStringServer from '../services/apiStringServer.js';

import theme from './themes/Theme';
import { ThemeProvider } from '@mui/material';

import Header from '../components/Header.js';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
//import TreeView2 from '../components/TreeView2.js';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import FooterHome from '../components/FooterHome.js';
import Add from '@mui/icons-material/Add';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Tree from 'rsuite/Tree'; //resolução do EcmaScript
import { styled } from '@mui/material';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Visibility from '@mui/icons-material/Visibility';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Share from '@mui/icons-material/Share';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales';

import InputMask from 'react-input-mask';

let columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'name',
    headerName: 'Nome',
    width: 150,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Nome '}
        <span role="img" aria-label="enjoy">
          🔤
        </span>
      </strong>
    ),
  },
  {
    field: 'process',
    headerName: 'Nº de Referência',
    width: 170,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Nº de Referência'}
        <span role="img" aria-label="enjoy">
          ♎
        </span>
      </strong>
    ),
  },
  {
    field: 'protocol',
    headerName: 'Protocolo',
    width: 150,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Protocolo '}
        <span role="img" aria-label="enjoy">
          📄
        </span>
      </strong>
    ),
  },
  {
    field: 'secretary',
    headerName: 'Secretaria',
    width: 250,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Secretaria '}
        <span role="img" aria-label="enjoy">
          🏛️
        </span>
      </strong>
    ),
  },
  {
    field: 'subcategory',
    headerName: 'Subcategoria',
    width: 330,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Subcategoria '}
        <span role="img" aria-label="enjoy">
          🏷️
        </span>
      </strong>
    ),
  },
  {
    field: 'city',
    headerName: 'Cidade',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Cidade '}
        <span role="img" aria-label="enjoy">
          🏙️
        </span>
      </strong>
    ),
  },
  {
    field: 'theme',
    headerName: 'Tema',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Tema '}
        <span role="img" aria-label="enjoy">
          📢
        </span>
      </strong>
    ),
  },
  {
    field: 'subtheme',
    headerName: 'Sub-Tema',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Sub-Tema '}
        <span role="img" aria-label="enjoy">
          📣
        </span>
      </strong>
    ),
  },
  {
    field: 'description',
    headerName: 'Descrição',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Descrição '}
        <span role="img" aria-label="enjoy">
          🗨️
        </span>
      </strong>
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 130,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Status '}
        <span role="img" aria-label="enjoy">
          ✔️
        </span>
      </strong>
    ),
  },
  {
    field: 'actions',
    headerName: 'Ações',
    renderCell: () => (
      <Actions />
    ),
    sortable: false,
    width: 100,
    headerAlign: 'center',
    filterable: false,
    align: 'center',
    disableColumnMenu: true,
    disableReorder: true,
  },
];

let rows = [];

let rowsArray = [];

let process = '';
let user = '';

let selected_city = 'queimados';

let users = [];

export class Actions extends Component {

  state = {
    openDialog: false,
    status: '1',
    copied: false,

    page_rows: [],
  }

  handleSee = async () => {

    setTimeout(() => {
      window.open(`${apiString}/process?process_id=${process}&user=${user}&selected_city=${selected_city}`, '_blank'); //enviar selected_city para process
    }, 1500);

  }

  handleShare = async () => {

    this.setState({ copied: true });

  }

  handleEdit = async () => {
    await this.setState({ openDialog: true });
    //let 
    //alert(JSON.stringify(rowsArray[0]));
  }

  handleDelete = async () => {

  }

  onStatusChange = async () => {

    try {
      let resp = await api.get('/updateprocess', {
        params: {
          process_id: process,
          status: this.state.status,
          selected_city: 'queimados'
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('edited')) {

            window.location.reload();

          } else {
            let msg = JSON.stringify(resp.data);
            console.log(msg);
          }
        }
      }
    } catch (err) {
      alert('Não foi possível buscar os dados do usuário. ' + err);
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div style={styles.html}>
        <ThemeProvider theme={theme}>
          <IconButton
            color="inherit"
            size="small"
            aria-label="see"
            onClick={this.handleSee}
          >
            <Visibility fontSize="small" />
          </IconButton>

          <CopyToClipboard text={`${apiString}/process?process_id=${process}&user=${user}&selected_city=${selected_city}`}>
            <IconButton
              color="inherit"
              size="small"
              aria-label="share"
              onClick={this.handleShare}
            >
              <Share fontSize="small" />
            </IconButton>
          </CopyToClipboard>

          <IconButton
            color="inherit"
            size="small"
            aria-label="edit"
            onClick={this.handleEdit}
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            aria-label="delete"
            onClick={this.handleDelete}
          >
            <Delete fontSize="small" />
          </IconButton>

          <Dialog open={this.state.openDialog} onClose={() => this.setState({ openDialog: false })}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Alteração</DialogTitle>
            <DialogContent>
              <DialogContentText color="#323232">
                Selecione ou preencha os campos que deseja alterar.
              </DialogContentText>

              <FormControl variant="outlined" fullWidth style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="outlined-theme-native-simple">
                  Status
                </InputLabel>
                <Select
                  autoFocus
                  native
                  value={this.state.status}
                  onChange={this.handleChange}
                  label="Status"
                  inputProps={{
                    name: 'status',
                    id: 'outlined-status-native-simple',
                  }}
                >
                  <option value="1">Pendente</option>
                  <option value="2">Regularizado</option>
                  <option value="3">Negado</option>
                </Select>
              </FormControl>

            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ openDialog: false })} style={{ color: '#d9be29' }}>
                Cancelar
              </Button>
              <Button onClick={async () => {
                this.setState({ openDialog: false });
                this.onStatusChange();
              }} style={{ color: '#d9be29' }}>
                Alterar
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    );
  }
}

class ProcessRegister extends Component {

  state = {
    user_id: '',
    login: '',
    option: '',
    selected_city: 'rios',
    secretary: '',
    secretary_id: '',
    name: '',

    processNumberMask: '999999-9/9999',
    processNumber: '',
    exerciseMask: '9999',
    exercise: '',
    dateMask: '99/99/9999',
    initial_date: '',
    final_date: '',
    circle: 'ambos',
    reporter: '',
    reviewer: '',
    city_selected: 'rj',

    row: true,

    data: [],
    children: [],

    organ: 'select',
    organs: [],

    keyType: 'nome',
    keyTypeMask: '',
    keyTypeValue: '',

    process_nature: 'select',
    process_natures: [],

    process_nature_nature: 'select',
    process_nature_natures: [],

    page_rows: [],

    open: false,
    open_error: false,
    msg: '',
  }

  async componentDidMount() {

    if (this.props.location.state) {
      await this.setState({ login: this.props.location.state.fields.login });
      await this.setState({ option: this.props.location.state.fields.option });
      await this.setState({ selected_city: this.props.location.state.fields.selected_city });
      await this.setState({ name: this.props.location.state.fields.name.split('"').join('') });
      await this.setState({ secretary: this.props.location.state.fields.secretary.split('"').join('') });
      await this.setState({ secretary_id: this.props.location.state.fields.secretary_id });
      await this.setState({ user_id: this.props.location.state.fields.user_id });
    } else {
      const idx = document.URL.indexOf('?');

      var params = [];
      if (idx !== -1) {
        var pairs = document.URL.substring(idx + 1, document.URL.length).split('&');
        //alert(pairs);
        for (var i = 0; i < pairs.length; i++) {
          let nameVal = pairs[i].split(',');
          nameVal = pairs[i].replace('login=', '');
          nameVal = nameVal.replace('option=', '');
          nameVal = nameVal.replace('selected_city=', '');
          nameVal = nameVal.replace('name=', '');
          nameVal = nameVal.replace('secretary=', '');
          nameVal = nameVal.replace('secretary_id=', '');
          nameVal = nameVal.replace('user_id=', '');
          params.push(nameVal);
        }
      }

      await this.setState({ login: decodeURI(params[0]) });
      await this.setState({ option: decodeURI(params[1]) });
      await this.setState({ selected_city: decodeURI(params[2]) });
      await this.setState({ name: decodeURI(params[3]) });
      await this.setState({ secretary: decodeURI(params[4]) });
      await this.setState({ secretary_id: decodeURI(params[5]) });
      await this.setState({ user_id: decodeURI(params[6]) });
    }

    await this.setState({ city_selected: this.state.selected_city });

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.setState({ row: false });
    } else {
      this.setState({ row: true });
    }

    await this.handleOrgans();
    await this.handleProcessNatures();

  }

  handleTableProcesses = async e => {

    try {
      let resp = await api.get('/process', {
        params: {
          secretary_id: this.state.secretary_id,
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          //alert(JSON.stringify(resp.data));
          if (JSON.stringify(resp.data).includes('protocol')) {
            users = resp.data;

            for (let i = 0; i < resp.data.length; i++) {
              let status = '';
              if (resp.data[i].status === 1) {
                status = '🟡 Pendente';
              } else {
                if (resp.data[i].status === 2) {
                  status = '🟢 Regularizado';
                } else {
                  if (resp.data[i].status === 3) {
                    status = '🔴 Negado';
                  }
                }
              }
              let aux = {
                id: `${resp.data[i].id}`,
                name: `${resp.data[i].process_name}`,
                protocol: `${resp.data[i].protocol}`,
                process: `${resp.data[i].process_number}`,
                secretary: `${resp.data[i].secretary_name}`,
                subcategory: `${resp.data[i].subcategory_name}`,
                city: `${resp.data[i].city} - ${resp.data[i].state}`,
                theme: `${resp.data[i].theme}`,
                subtheme: `${resp.data[i].subtheme}`,
                description: `${resp.data[i].description}` === 'undefined' ? '' : `${resp.data[i].description}`,
                status: status,
                latitude: `${resp.data[i].latitude}`,
                longitude: `${resp.data[i].longitude}`,
              };
              rows = Object.assign([], rows);
              rows.push(aux);
            }

            this.setState({ page_rows: rows });

          } else {
            let msg = JSON.stringify(resp.data);
            console.log(msg)
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

    this.setState({ page_rows: rows });

  }

  handleOrgans = async e => {

    try {

      let resp = await api.get('/organs', {
        params: {
          city: this.state.city_selected,
        }
      });

      await this.setState({ organs: resp.data });

    } catch (err) {
      //this.setState({ open_error: true });
      //this.setState({ msg: 'Erro ao buscar os órgãos' });
      alert('Erro ao buscar os órgãos. ' + err);
    }

  }

  handleProcessNatures = async e => {

    try {

      let resp = await api.get('/processnatures');

      await this.setState({ process_natures: resp.data });

    } catch (err) {
      //this.setState({ open_error: true });
      //this.setState({ msg: 'Erro ao buscar as naturezas dos processos' });
      alert('Erro ao buscar as naturezas dos processos. ' + err);
    }

  }

  handleProcessNatureNatures = async e => {

    try {

      let resp = await api.get('/processnaturenatures', {
        params: {
          process_nature_id: this.state.process_nature,
        }
      });

      await this.setState({ process_nature_natures: resp.data });

    } catch (err) {
      //this.setState({ open_error: true });
      //this.setState({ msg: 'Erro ao buscar as naturezas dos processos' });
      alert('Erro ao buscar as naturezas de natureza do processo. ' + err);
    }

  }

  handleMask = async e => {
    await this.setState({ [e.target.name]: e.target.value });

    if (this.state.keyType === "nome") {
      this.setState({ keyTypeMask: '' });
    }
    if (this.state.keyType === "cpf") {
      this.setState({ keyTypeMask: '999.999.999-99' });
    }
  }

  handleChangeNature = async e => {
    await this.setState({ [e.target.name]: e.target.value });

    await this.handleProcessNatureNatures();
  }

  handleSubmit = async e => {

    e.preventDefault();

    const data = {
      process_number: this.state.processNumber,
      exercise: this.state.exercise,
      initial_date: this.state.initial_date,
      final_date: this.state.final_date,
      circle: this.state.circle,
      reporter: this.state.reporter,
      reviewer: this.state.reviewer,
      city_selected: this.state.city_selected,
      organ: this.state.organ,
      keyType: this.state.keyType,
      keyTypeValue: this.state.keyTypeValue,
      process_nature: this.state.process_nature,
      process_nature_nature: this.state.process_nature_nature,
      user_id: this.state.user_id,
    };

    try {

      const resp = await api.post('/processes', data);

      if (resp.status === 200) {
        this.setState({ open: true });
        this.setState({ msg: 'Processo cadastrado com sucesso!' });
      }

    } catch (err) {
      this.setState({ open_error: true });
      this.setState({ msg: 'Erro ao cadastrar o processo' });
    }

  }

  handleChange = async e => {
    await this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div style={styles.html}
      >

        <ThemeProvider theme={theme}>

          <Header
            history={this.props.history}
            login={this.state.login}
            option={this.state.option}
            selected_city={this.state.selected_city}
            name={this.state.name}
            secretary={this.state.secretary}
            secretary_id={this.state.secretary_id}
            user_id={this.state.user_id}
            {...this.props}
          />

          <Box sx={{
            backgroundColor: '#E5E6F0',
          }}
          >

            {this.state.row ? (
              <div style={styles.directionRow}>
                
                <Box
                  sx={{
                    backgroundColor: '#bfcadb',
                    borderRadius: 5,
                    margin: 10,
                    marginTop: 30,
                    width: '35%',
                  }}
                >
                  {/** cadastro de subcategoria */}
                  <Container maxWidth="lg" style={{ marginTop: 15 }}>
                    <form id="add_process" onSubmit={this.handleSubmit}>

                      <Typography variant="h6" style={{ marginLeft: 10 }}>
                        Cadastro de processo
                      </Typography>

                      <InputMask
                        {...this.props.value}
                        mask={this.state.processNumberMask}
                        fullWidth
                        required
                        maskChar=" "
                        name="processNumber"
                        id="processNumber"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.processNumber}
                      >
                        {(inputProps) =>
                          <TextField
                            {...inputProps}
                            variant="outlined"
                            margin="normal"
                            label="Nº do processo"
                            style={{ width: '45%' }}
                          />
                        }
                      </InputMask>

                      <InputMask
                        {...this.props.value}
                        mask={this.state.exerciseMask}
                        fullWidth
                        required
                        maskChar=" "
                        name="exercise"
                        id="exercise"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.exercise}
                      >
                        {(inputProps) =>
                          <TextField
                            {...inputProps}
                            variant="outlined"
                            margin="normal"
                            label="Exercício"
                            style={styles.input}
                          />
                        }
                      </InputMask>

                      <InputMask
                        {...this.props.value}
                        mask={this.state.dateMask}
                        maskChar=" "
                        required
                        name="initial_date"
                        id="initial_date"
                        type="text"
                        style={{ width: 250 }}
                        onChange={this.handleChange}
                        value={this.state.initial_date}
                      >
                        {(inputProps) =>
                          <TextField
                            {...inputProps}
                            variant="outlined"
                            margin="normal"
                            label="Data de atuação inicial"
                          />
                        }
                      </InputMask>

                      <InputMask
                        {...this.props.value}
                        mask={this.state.dateMask}
                        maskChar=" "
                        required
                        name="final_date"
                        id="final_date"
                        type="text"
                        style={{ width: 250, marginLeft: 10 }}
                        onChange={this.handleChange}
                        value={this.state.final_date}
                      >
                        {(inputProps) =>
                          <TextField
                            {...inputProps}
                            variant="outlined"
                            margin="normal"
                            label="Data de atuação final"
                          />
                        }
                      </InputMask>

                      <FormControl variant="outlined" fullWidth style={{ marginBottom: 15, marginTop: 18, width: '50%' }}>
                        <InputLabel htmlFor="outlined-circle-native-simple">
                          Esfera *
                        </InputLabel>
                        <Select
                          native
                          required
                          value={this.state.circle}
                          onChange={this.handleChange}
                          label="Esfera"
                          inputProps={{
                            name: 'circle',
                            id: 'outlined-circle-native-simple',
                          }}
                        >
                          <option value="ambos">Ambos</option>
                          <option value="estadual">Estadual</option>
                          <option value="municipal">Municipal</option>
                        </Select>
                      </FormControl>

                      <TextField
                        autoComplete="fname"
                        name="reporter"
                        variant="outlined"
                        required
                        fullWidth
                        id="reporter"
                        label="Relator"
                        onChange={this.handleChange}
                        value={this.state.reporter}
                      />

                      <TextField
                        autoComplete="fname"
                        name="reviewer"
                        variant="outlined"
                        required
                        fullWidth
                        id="reviewer"
                        label="Revisor"
                        style={styles.input2}
                        onChange={this.handleChange}
                        value={this.state.reviewer}
                      />

                      <FormControl variant="outlined" fullWidth style={{ marginBottom: 15, marginTop: 18, width: '45%' }}>
                        <InputLabel htmlFor="outlined-city_selected-native-simple">
                          Ente Federativo *
                        </InputLabel>
                        <Select
                          native
                          required
                          disabled
                          value={this.state.city_selected}
                          onChange={this.handleChangeCity} //gerar os órgãos de acordo com a cidade
                          label="Ente Federativo"
                          inputProps={{
                            name: 'city_selected',
                            id: 'outlined-city_selected-native-simple',
                          }}
                        >
                          <option value="cabo">Cabo Frio</option>
                          <option value="campos">Campos</option>
                          <option value="itaocara">Itaocara</option>
                          <option value="nova">Nova Iguaçu</option>
                          <option value="queimados">Queimados</option>
                          <option value="rj">Rio de Janeiro</option>
                          <option value="tresrios">Três Rios</option>
                          <option value="paulo">Paulo de Frontin</option>
                          <option value="saquarema">Saquarema</option>
                        </Select>
                      </FormControl>

                      <FormControl variant="outlined" fullWidth style={{ marginBottom: 15, marginTop: 18, width: '45%', marginLeft: 10 }}>
                        <InputLabel htmlFor="outlined-organ-native-simple">
                          Órgão/Origem *
                        </InputLabel>
                        <Select
                          native
                          required
                          value={this.state.organ}
                          onChange={this.handleChange}
                          label="Órgão/Origem"
                          inputProps={{
                            name: 'organ',
                            id: 'outlined-organ-native-simple',
                          }}
                        >
                          <option value={`select`}>Selecione um Órgão/Origem</option>
                          {this.state.organs.map((item) => 
                            <option value={`${item.id}`}>{item.organ_name}</option>
                          )}
                        </Select>
                      </FormControl>

                      <FormControl component="fieldset">
                        <FormLabel component="legend">Interessado</FormLabel>
                        <RadioGroup
                          aria-label="keyType1"
                          name="keyType"
                          value={this.state.keyType}
                          onChange={this.handleMask}
                          style={{ flexDirection: 'row' }}
                        >
                          <FormControlLabel value="nome" control={<Radio />} label="Nome" />
                          <FormControlLabel value="cpf" control={<Radio />} label="CPF" />
                        </RadioGroup>
                      </FormControl>

                      <InputMask
                        {...this.props.value}
                        mask={this.state.keyTypeMask}
                        fullWidth
                        required
                        maskChar=" "
                        name="keyTypeValue"
                        id="keyTypeValue"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.keyTypeValue}
                      >
                        {(inputProps) =>
                          <TextField
                            {...inputProps}
                            variant="outlined"
                            margin="normal"
                            label="Nome/CPF"
                          />
                        }
                      </InputMask>

                      <div style={styles.directionColumn}>
                        <FormControl variant="outlined" fullWidth style={{ marginBottom: 15, marginTop: 18 }}>
                          <InputLabel htmlFor="outlined-process_nature-native-simple">
                            Natureza do processo *
                          </InputLabel>
                          <Select
                            native
                            required
                            value={this.state.process_nature}
                            onChange={this.handleChangeNature}
                            label="Natureza do processo"
                            inputProps={{
                              name: 'process_nature',
                              id: 'outlined-process_nature-native-simple',
                            }}
                          >
                            <option value={`select`}>Selecione uma Natureza do Processo</option>
                            {this.state.process_natures.map((item) =>
                              <option value={`${item.id}`}>{item.name}</option>
                            )}
                          </Select>
                        </FormControl>

                        <FormControl variant="outlined" fullWidth style={{ marginBottom: 15, marginTop: 5 }}>
                          <InputLabel htmlFor="outlined-process_nature_nature-native-simple">
                            Natureza da natureza do processo *
                          </InputLabel>
                          <Select
                            native
                            required
                            value={this.state.process_nature_nature}
                            onChange={this.handleChange}
                            label="Natureza da natureza do processo"
                            inputProps={{
                              name: 'process_nature_nature',
                              id: 'outlined-process_nature_nature-native-simple',
                            }}
                          >
                            <option value={`select`}>Selecione uma Natureza da Natureza do Processo</option>
                            {this.state.process_nature_natures.map((item) =>
                              <option value={`${item.id}`}>{item.name}</option>
                            )}
                          </Select>
                        </FormControl>
                      </div>

                      <Button
                        type="submit"
                        variant="contained"
                        style={styles.submit}
                        startIcon={<Add />}
                      >
                        Cadastrar
                      </Button>
                      
                    </form>
                  </Container>

                </Box>

                
                <DataGrid
                  slots={{ toolbar: GridToolbar }}
                  style={{ height: 900 }}
                  rows={this.state.page_rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 7 },
                    },
                  }}
                  pageSizeOptions={[7]}
                  disableRowSelectionOnClick
                  localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                  onCellClick={async (row) => {
                    rowsArray = [];
                    await rowsArray.push(row);
                    process = '';
                    process = rowsArray[0].row.id;
                    this.setState({ latitude: rowsArray[0].row.latitude });
                    this.setState({ longitude: rowsArray[0].row.longitude });
                    this.setState({ zoom: 17 });
                  }}
                />

              </div>
            ) : (
              <div style={styles.directionColumn}>

                <Box
                  sx={{
                    backgroundColor: '#E5E6F0',
                    margin: 10,
                    width: '93%',
                    height: 300,
                    marginTop: -400
                  }}
                >
                  {/** cadastro de subcategoria */}
                  <Container maxWidth="lg" style={{ marginTop: 15 }}>
                    <form id="add_process" onSubmit={this.handleSubmit}>

                      

                    </form>
                  </Container>
                </Box>

              </div>
            )}

          </Box>

        </ThemeProvider>

        <FooterHome />

      </div>
    );
  }
}

let styles = {
  html: {
    backgroundColor: '#E5E6F0',
    margin: -8
  },

  directionRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
  },

  directionColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },

  input: {
    marginLeft: 10,
    width: '45%',
  },

  input2: {
    marginTop: 18,
  },

  submit: {
    width: 120,
    margin: 5,
    marginBottom: 20,
    textTransform: 'none',
    backgroundColor: '#d9be29',
    fontSize: 16,
  },

};

export default withRouter(Actions);